import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
// APIモジュール
import { API } from "aws-amplify";
import {
  Button,
  Container,
  TextField,
  Paper,
  Typography,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import HelpButton from "../component/HelpButton";
import { makeStyles } from "@material-ui/core/styles";

import { loadStripe } from "@stripe/stripe-js";

if (process.env.NODE_ENV === "development") {
  var public_key = `${process.env.REACT_APP_STRIPE_PUBLIC_DEV}`;
  var account_price = "price_1Ic3FjDEZeQcJl0af1C355GP";
  var sub_account_price = "price_1JDRwoDEZeQcJl0ahNxIQIyp";
  var shop_price = "price_1KllM5DEZeQcJl0aV3UKyeVt";
  var base_url = "http://localhost:3000";
} else if (process.env.NODE_ENV === "production") {
  public_key = `${process.env.REACT_APP_STRIPE_PUBLIC_PRO}`;
  account_price = "price_1Ig5zLDEZeQcJl0aEyyDBRRo";
  sub_account_price = "price_1JDS1jDEZeQcJl0aKZjywQLL";
  shop_price = "price_1JSYsYDEZeQcJl0avLwHgMIq";
  base_url = "https://new.pluselect.com";
}
console.log(process.env.NODE_ENV);
const api_name = process.env.REACT_APP_API_NAME;

import shopImage from "../assets/img/shop.png";
import kaiinIdImage from "../assets/img/kaiinId.png";

import BuymaLicense from "../component/BuymaLicense";
import ShopLicense from "../component/ShopLicense";
import License from "../component/License";

const useStyles = makeStyles((theme) => ({
  field: {
    width: "100%",
    marginTop: theme.spacing(3),
    alignItems: "center",
  },
  button: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  interval: {
    marginTop: theme.spacing(5),
  },
  paper: {
    alignItems: "center",
    marginTop: theme.spacing(5),
    margin: theme.spacing(3),
    padding: theme.spacing(8),
  },
  priceText: {
    marginLeft: "10px",
  },
  image: {
    width: "100%",
  },
}));

export default function Home(props) {
  const classes = useStyles();
  const history = useHistory();
  const userInfo = props.userInfo;
  const userGroup = props.userGroup;
  const userBuyma = props.userBuyma;
  const profile = props.profile;
  const trial = props.trial;
  const userId = props.userId;
  const customerId = props.customerId;
  const [coupon, setCoupon] = useState();
  const [subAccount, setSubAccount] = useState(false);

  const [buyma, setBuyma] = useState();
  const [kaiinId, setKaiinId] = useState();
  const [link, setLink] = useState();

  // validationチェック
  const [msg, setMsg] = useState();
  const [msg2, setMsg2] = useState();
  const [accountCheckout, setAccountCheckout] = useState(false);
  const [shopCheckout, setShopCheckout] = useState(false);

  useEffect(() => {
    if (profile) {
      if (!profile.name) {
        history.push("/profile");
      }
    }
  }, [profile]);

  useEffect(() => {
    if (userBuyma) {
      let approvedAccount = userBuyma.filter((item) => item["approved"] === 1);
      let mainAccount = approvedAccount.filter((item) => !item["subAccount"]);
      if (mainAccount.length > 0) {
        console.log("サブアカウント決済が有効です");
        setSubAccount(true);
      }
    }
  }, [userBuyma]);

  const handlePayment = async function (priceName, mode) {
    let priceId = "";
    if (priceName === "account_price") {
      if (subAccount) {
        priceId = sub_account_price;
      } else {
        priceId = account_price;
      }
    } else if (priceName === "shop_price") {
      priceId = shop_price;
    }
    console.log(priceId, mode);
    let stripe = await loadStripe(public_key);
    var metadata = {
      userId: userId,
    };
    if (priceId === account_price || priceId === sub_account_price) {
      // BUYMA1アカウント
      setAccountCheckout(true);
      // アフィリエイト経由の場合
      if (userInfo.stripeParentAccount) {
        metadata.stripeParentAccount = userInfo.stripeParentAccount;
      }
      metadata["buyma"] = buyma;
      metadata["kaiinId"] = kaiinId;
    } else if (priceId === shop_price) {
      // 新規ショップ追加
      setShopCheckout(true);
      metadata["link"] = link;
    }
    createCheckoutSession(priceId, mode, metadata).then((response) => {
      console.log(response.sessionId);
      stripe
        .redirectToCheckout({
          sessionId: response.sessionId,
        })
        .then((res) => {
          console.log(res);
        });
    });
  };

  const createCheckoutSession = function (priceId, mode, metadata) {
    // エラーの原因が分からない時はconsoleのurlをクリック！
    // Customerを編集
    return new Promise(function (resolve, reject) {
      var query = {
        body: {
          mode: mode,
          priceId: priceId,
          quantity: 1,
          success_url: base_url + "/#/thankyou/{CHECKOUT_SESSION_ID}",
          cancel_url: base_url,
          metadata: metadata,
          coupon: coupon,
          customerId: customerId,
        },
      };
      console.log(query);
      API.post(api_name, "/stripe/createCheckoutSession", query)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const handleChange = function (e) {
    // console.log(e.target.id)
    // console.log(e.target.value)
    let id = e.target.id;
    let value = e.target.value;
    if (id === "buyma") {
      setBuyma(value);
    } else if (id === "kaiinId") {
      if (value < 100000 || 99999999 < value) {
        setMsg("入力された値は有効ではありません。");
      } else {
        setMsg("");
        setKaiinId(value);
      }
    } else if (id === "link") {
      setLink(value);
      try {
        const myURL = new URL(value);
        console.log(myURL);
        if (myURL.hostname.indexOf(".") !== -1) {
          setMsg2("");
        } else {
          setMsg2("有効なショップのURLリンクを記入してください。");
        }
      } catch (error) {
        setMsg2("有効なショップのURLリンクを記入してください。");
      }
    }
  };

  return (
    <React.Fragment>
      {profile.name ? (
        <Typography variant="h4" align="left" gutterBottom>
          ようこそ、{profile.name}さん
        </Typography>
      ) : (
        <Typography variant="h4" align="center" color="error" gutterBottom>
          プロフィール登録をお願いします
        </Typography>
      )}

      <Alert variant="outlined" severity="info">
        このページではツールの契約や契約情報の確認、新しく取得したいショップの購入ができます。
      </Alert>

      {trial ? (
        <Container className={classes.interval}>
          <Paper className={classes.paper} elevation={3} variant="outlined">
            <Typography variant="h4" align="center" gutterBottom>
              現在トライアル期間中です。
            </Typography>
            <Typography paragraph align="center">
              <Link color="textSecondary" to="/download">
                こちら
              </Link>
              よりシステムをダウンロードしてお使いください。
              <br />
              トライアル期間の取得上限は100品に設定しております。
              <br />
              取得上限を解放したい場合は、下のフォームを入力して決済へ進むをクリックしてください。
              <br />
              トライアルが終了しても自動で契約されることはありません。
            </Typography>
          </Paper>
        </Container>
      ) : null}

      <Container className={classes.interval}>
        <Typography variant="h3" align="center" gutterBottom>
          PLUSELECTシステム契約ページ
        </Typography>
      </Container>

      <Paper className={classes.paper} elevation={3} variant="outlined">
        <Container>
          <BuymaLicense {...props} />
        </Container>

        <Container className={classes.interval}>
          <Typography variant="h4" color="error">
            {msg}
          </Typography>

          <Typography variant="h4">
            <HelpButton
              title={
                <>
                  <Typography variant="caption" display="block">
                    こちらを購入していただくと、商品リスト作成ツール、画像加工ツール、出品ツール、BuyManager、在庫管理システム全て制限なくご利用いただけます。
                    <br />
                    <br />
                    BUYMA会員IDに関しては、BUYMAの「出品者ページ」の左上に会員IDが載っていますのでここの数字をコピーして貼り付けます。
                  </Typography>
                  <img src={kaiinIdImage} className={classes.image}></img>
                  <Button
                    variant="contained"
                    target="_blank"
                    fullWidth
                    href="https://hp.pluselect.com/system-description/akauntozhui-jia-toqu-de-siyotuhuzhui-jia"
                  >
                    詳しくはこちら
                  </Button>
                </>
              }
            />
            新PLUSELECTシステム
            <Typography
              className={classes.priceText}
              variant="h4"
              color="textSecondary"
              display="inline"
            >
              {subAccount
                ? "¥9,800（税込） / 月 【２アカウント目以降特別プラン】"
                : "¥19,800（税込） / 月"}
            </Typography>
          </Typography>
          <Typography variant="caption">
            BUYMA1アカウントで<strong>5,000品MAX出品</strong>
            ができて、在庫管理も<strong>全て制限なく使えるプラン</strong>です。
            <br />
            複数アカウントをお持ちの方は2アカウント目以降の特別プランもございますので、お気軽にご連絡ください。
            <br />
            BUYMAで使用しているシステムを導入したいアカウントの名前とBUYMAの会員IDを入力し、「決済へ進む」をクリックしてください。
          </Typography>

          <TextField
            id="buyma"
            label="アカウント名"
            type="text"
            className={classes.textField}
            onChange={(e) => handleChange(e)}
          />
          {buyma ? null : (
            <Typography variant="caption" color="error">
              アカウント名は必須です。
            </Typography>
          )}
          <TextField
            id="kaiinId"
            label="BUYMA会員ID"
            type="number"
            className={classes.textField}
            onChange={(e) => handleChange(e)}
          />
          {kaiinId ? null : (
            <Typography variant="caption" color="error">
              BUYMA会員IDは必須です。
            </Typography>
          )}
          <Button
            id="accountCheckout"
            className={classes.button}
            disabled={!userId || !buyma || !kaiinId || msg || accountCheckout}
            variant="contained"
            onClick={() => handlePayment("account_price", "subscription")}
          >
            決済へ進む
          </Button>
          <Typography variant="caption">
            ※ BUYMAに出品する際や、在庫管理をする際に使用します
          </Typography>
        </Container>
      </Paper>

      <Paper className={classes.paper} elevation={3} variant="outlined">
        <Container>
          <ShopLicense {...props} />
        </Container>

        <Container className={classes.interval}>
          <Typography variant="h4" color="error">
            {msg2}
          </Typography>

          <Typography variant="h4">
            <HelpButton
              title={
                <>
                  <Typography variant="caption" display="block">
                    取得したいショップをこちらで決済していただくと「商品リスト作成ツール」でそのショップから取得できるようになります。
                    <br />
                    こちらは買い切りになりますので、一度ご購入いただければずっとご利用いただけます。
                  </Typography>
                  <img src={shopImage} className={classes.image}></img>
                  <Button
                    variant="contained"
                    target="_blank"
                    fullWidth
                    href="https://hp.pluselect.com/system-description/akauntozhui-jia-toqu-de-siyotuhuzhui-jia"
                  >
                    詳しくはこちら
                  </Button>
                </>
              }
            />
            新規ショップ追加
            <Typography
              className={classes.priceText}
              variant="h4"
              color="textSecondary"
              display="inline"
            >
              ¥10,000（税込） / 1ショップ
            </Typography>
          </Typography>
          <Typography variant="caption">
            追加希望ショップのトップページのURLを記入して「決済へ進む」ボタンをクリックしてください。
            <br />
            決済完了後、1週間前後で開発をして登録させていただきます。
            <br />
            ログインを必要とするサイトの開発や、特殊なショップの開発に関してはLINEより別途ご相談ください。
          </Typography>
          <TextField
            id="link"
            label="URL"
            type="text"
            className={classes.textField}
            onChange={(e) => handleChange(e)}
          />
          {link ? null : (
            <Typography variant="caption" color="error">
              追加希望ショップのトップページのURLをご入力ください。
            </Typography>
          )}
          <Button
            id="shopCheckout"
            className={classes.button}
            disabled={!userId || !link || msg2 || shopCheckout}
            variant="contained"
            onClick={() => handlePayment("shop_price", "payment")}
          >
            決済へ進む
          </Button>
        </Container>
      </Paper>

      <Paper className={classes.paper} elevation={3} variant="outlined">
        <Container>
          <Typography variant="h4">
            <HelpButton
              title={
                <>
                  <Typography variant="caption" display="block">
                    こちら開発用に設定しているクーポンコードの入力欄です。
                    <br />
                    基本的にクーポンは発行しておりませんので、クーポンに関するお問い合わせはお控え頂きますようよろしくお願いいたします。
                  </Typography>
                </>
              }
            />
            クーポンコード設定
          </Typography>
          <TextField
            id="coupon"
            label="クーポンコード"
            type="text"
            className={classes.textField}
            onChange={(e) => setCoupon(e.target.value)}
          />
        </Container>
      </Paper>

      <License {...props} />
    </React.Fragment>
  );
}
